import React, {useEffect} from 'react';
import {Route, Routes, useLocation, useParams} from 'react-router';

import {Page404} from "../../404";
import {ManyRecs} from "./many";
import {OneRec} from "./one";

const ManyRecsRoute = () => {
    const location = useLocation();
    return <ManyRecs search={new URLSearchParams(location.search)} />;
};

const OneRecRoute = () => {
    const {resid} = useParams();
    const location = useLocation();
    return <OneRec recid={resid} search={new URLSearchParams(location.search)} />;
};

const RecsPage = () => {
    useEffect(() => {
        console.log("Recs page");
    }, [])

    return <Routes>
        <Route path="/" element={<ManyRecsRoute />} />
        <Route path="/:resid" element={<OneRecRoute />} />
        <Route path="*" element={<Page404 />} />
    </Routes>
}

export { RecsPage };
